'use strict';
module.exports = require('./InputNumber.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/inputnumber/index.js
// module id = 24
// module chunks = 1